import { AbstractModel } from ".";

export default class OrganizationUsersGroup extends AbstractModel {
  type = "OrganizationUsersGroup";
  id?: string;
  name?: string;
}
